import { Component, OnInit, Inject, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator, MatSort, MatPaginatorIntl, Sort, PageEvent, MatExpansionModule } from '@angular/material';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
import { UploadService } from '../../services/upload/upload.service';
import { Subscription } from 'rxjs/Subscription';
import * as momenttimezone from 'moment-timezone';
import { ParComplaintsDocumentsService } from '../../services/par-complaints-documents/par-complaints-documents.service';
import * as moment from 'moment';
import { DownloadService } from '../../services/download/download.service';
import { ParComplaintsDocumentDeleteDialogComponent } from '../par-complaints-document-delete-dialog/par-complaints-document-delete-dialog.component';
import { environment } from '../../../environments/environment';
declare let ga: any;
@Component({
  selector: 'app-manage-complaint-view-documents-dialogue',
  templateUrl: './manage-complaint-view-documents-dialogue.component.html',
  styleUrls: ['./manage-complaint-view-documents-dialogue.component.css']
})
export class ManageComplaintViewDocumentsDialogueComponent implements OnInit {

  displayedColumns = ['DocumentName', 'UploadedOn', 'UploadedBy', 'FileEdit'];
  dataSource: MatTableDataSource<ViewDocsData>;
  public docsList: any;
  length: any;
  ispaginationFlag: boolean = false;
  private subscription: Subscription;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageEvent: PageEvent;
  pageSize = 10;
  message: string;
  errorMessage: string = '';
  errorEnable: boolean = false;
  signedUrl;
  deleteId: any;
  hideDeleteButton: boolean = false;
  firstName;
  lastName;
  loginId;

  constructor(public parComplaintsDocumentsService: ParComplaintsDocumentsService, public dialogRef: MatDialogRef<ManageComplaintViewDocumentsDialogueComponent>,
              private googleAnalyticsService: GoogleAnalyticsService,
              public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public complaintsData: any,
              private uploadService: UploadService,
              public ref: ChangeDetectorRef,
              private downloadService: DownloadService,
              ) {
  }

  ngOnInit() {
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    var role = localStorage.getItem('Role');
    if ( role === 'PC PAR Vendor Relations'){
        this.hideDeleteButton = true;
    }
    this.getDocs(this.complaintsData.ComplaintId);
    this.refreshList();
  }

  refreshList(){
    this.parComplaintsDocumentsService.load.subscribe(res=>{
      if(res === "success"){
        this.getDocs(this.complaintsData.ComplaintId);
      }
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  getDocs(complaintId) {
    this.docsList = [];
    this.parComplaintsDocumentsService.getDocuments(complaintId).subscribe(res => {
      if (!res.Documents) {
        this.docsList = [];
        this.ispaginationFlag = false;
        this.dataSource = null;
        this.message = "No Documents are available for the Complaint";
      } else {
        this.message = '';
        this.docsList = res.Documents;
        for (let i = 0; i < this.docsList.length; i++) {
          if (this.docsList[i].UploadedOn) {
            this.docsList[i].UploadedOn = moment(this.docsList[i].UploadedOn).format('MM/DD/YYYY');
          }
        }
        this.dataSource = new MatTableDataSource(this.docsList);
        this.dataSource.sort = this.sort;
        this.length = this.docsList.length;
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        } else {
          this.ispaginationFlag = true;
        }
        if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
          this.paginator.pageIndex = this.paginator.pageIndex - 1;
        }
        this.dataSource.paginator = this.paginator;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) {
            return `0 van ${length}`;
          }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        };
        this.dataSource.paginator._intl = paginatorIntl;
      }
    }, err => {
      this.errorMessage = "View Documents Service : " + err;
      this.errorEnable = true;
    });
  }

  downloadDoc(docDate) {
    let body = {
      "filePath": docDate.DocumentLink
    };

    this.downloadService.getDownloadSignedURL(body).subscribe((res) => {
      ga('CompliantsTracker.send', 'event',this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[8],this.loginId, 1);
      this.signedUrl = res.Info;
      window.open(this.signedUrl, "_blank");
    }, err => {
      this.errorMessage = "Dowload Documents Service : " + err;
      this.errorEnable = true;
    });
  }

  ngOnDestroy() {
    if (this.subscription){
      this.subscription.unsubscribe();
    }
  }

  /*deleteManageComplaintDocument(getDeleteData){
    this.deleteId= getDeleteData._id;
    this.deleteComplaintDocumentDetails(this.deleteId);
  }*/

  deleteComplaintDocumentDetails(data) {
    const dialogRef = this.dialog.open(ParComplaintsDocumentDeleteDialogComponent, {
      width: '400px',
      height: '250px',
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}

export interface ViewDocsData {
  "DocumentName": String;
  "UploadedBy": String
  "UploadedOn": Date;
  "FileEdit" : any;
}



// WEBPACK FOOTER //
// ./src/app/components/manage-complaint-view-documents-dialogue/manage-complaint-view-documents-dialogue.component.ts